import React from 'react'
import { connect } from 'formik'
import { Grid, Typography } from '@paintscout/ui'
import { useClientOptions } from '@paintscout/ui-business'
import { getObjectLabels } from '@paintscout/util/builder'
import type {
  PresentationSectionFormProps,
  FormikPresentationSectionConnectProps,
  FormikPresentationSectionValues
} from '../../'

const WorkOrderForm = (_: PresentationSectionFormProps & FormikPresentationSectionConnectProps) => {
  const { options } = useClientOptions()
  const objectLabels = getObjectLabels({ options })
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant={'body1'}>
          This section will show the {objectLabels.workOrder.value} as it appears on the {objectLabels.workOrder.value}{' '}
          page.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant={'body1'}>
          It will always show in the customer&lsquo;s header Navigation, with a title of &quot;
          {objectLabels.workOrder.value}&quot;
        </Typography>
      </Grid>
    </Grid>
  )
}
export default connect<PresentationSectionFormProps, FormikPresentationSectionValues>(WorkOrderForm)
